import logo from 'assets/logoIcon.png'
import CardCustom from 'components/CardCustom'
import Interior from 'components/Interior'
import PageHeading from 'components/shared/PageHeading'
import { Col, Container, Row } from 'react-bootstrap'

import icon1 from 'assets/exterIcon1.png'
import icon2 from 'assets/exterIcon1.png'
import exter1 from 'assets/exter1.png'
import exter2 from 'assets/exter2.png'
import expIcon1 from 'assets/expIcon1.png'
import expIcon2 from 'assets/expIcon2.png'
import exp1 from 'assets/exp1.png'
import exp2 from 'assets/exp2.png'
const Solutions = () => {
    return (

        <Container   >


            <div className='d-flex justify-content-center align-items-center text-center  pt-5 pb-4'>

                <div >


                    <div className='text-center mb-3 mt-lg-5'>
                        <PageHeading center={true} image={logo} text={"Solution"} />
                    </div>
                    <h1 className='fw-bold'>Solutions: </h1>
                    <h1>
                        <span className="fw-bold">Activating Your</span>
                        <i className='px-2'>Digital Space</i>
                    </h1>

                    <Col md={7} className='mx-auto mt-3'>
                        <p>Explore Living Wall’s custom solutions for high-end digital art, interactive displays, and immersive experiences tailored to your audience.</p>
                    </Col>


                    <h3 className='py-3 mb-lg-4'><i>INTERIOR</i></h3>
                </div>
            </div>

            <Interior />



            <h3 className='p-3 text-center my-md-5  pt-md-5 my-4'><i>EXTERIOR</i></h3>
            <Row>

                {exterData?.map((m, i) =>
                    <Col lg={6} xs={12} key={i} className='mb-lg-0 mb-4' >
                        <CardCustom heading={m.heading} title={m.title} image={m.image} icon={m.icon} para={m.para} />
                    </Col>

                )}
            </Row>

            <h3 className='pt-3 text-center my-md-5  pt-md-5 my-4'><i>EXPERIENCE</i></h3>
            <Row>

                {expData?.map((m, i) =>
                    <Col lg={6} xs={12} key={i} className='mb-lg-0 mb-4' >
                        <CardCustom heading={m.heading} title={m.title} image={m.image} icon={m.icon} para={m.para} />
                    </Col>

                )}
            </Row>
        </Container>

    )
}

export default Solutions


const exterData = [



    {
        image: exter1, icon: icon1, title: "LED Screen Facade", heading: "Ideal for urban spaces that require dynamic, ever-changing messaging.",
        para: <>
            <p className='mb-2'>
                Our <strong>LED Screen Facades</strong> seamlessly integrate with architectural structures to offer a distinctive design edge. They add character to city-shaping projects, increasing occupancy rates and visitor engagement.
            </p>
            <p className='mb-0'>
                Fully customizable, these facades serve as a powerful medium for brand storytelling, corporate identity, and <strong className='px-1'>innovative lighting solutions</strong>.
            </p>
        </>
    },
    {
        image: exter2, icon: icon2, title: "Digital Sculpture", heading: "Transform everyday locations into inspiring, vibrant cultural hubs.",
        para: <>
            <p className='mb-0'>
                <strong className='pe-1'>Digital Sculptures</strong> bridge the physical and digital worlds to enrich the human experience. By blending indoor elements with the outdoors, they create excitement and familiarity. The content acts as a source of inspiration, encouraging more frequent visits through creative engagement and storytelling.
            </p>
        </>
    }
]
const expData = [



    {
        image: exp1, icon: expIcon1, title: "Interactive", heading: "Dynamic solutions that educate, entertain, and put the user first.",
        para: <>
            <p className='mb-0'>
                <strong className='pe-1'>Interactive solutions</strong> provide vivid visualization and clear insights, making information easy to digest. Ergonomically designed with multi-touch technology in mind, these displays revolutionize engagement by guiding users through an intuitive and innovative journey.
            </p>
        </>
    },
    {
        image: exp2, icon: expIcon2, title: "Brand Experience", heading: "Unparalleled engagement that drives real results.",
        para: <>
            <p className='mb-0'>
                <strong className='pe-1'>Brand Experiences</strong> transform spatial environments to enhance the customer journey and generate excitement for your products. By leveraging the latest technology to emotionally connect with your audience, we build lasting loyalty and turn every interaction into a potential conversion.
            </p>
        </>
    }
]
